import tw, { styled } from 'twin.macro';

import { files } from '../../../libs/assets';

export const PageIntroWrapper = styled.section`
  ${tw`flex flex-col gap-8 justify-center items-center px-8 py-12 lg:py-24 bg-no-repeat`};
  background-image: url(${files.wavyPatternLeft}), url(${files.wavyPatternRight});
  background-position: left center, right center;

  h1 {
    ${tw`md:w-4/5 xl:w-3/5 text-center mb-0`};
    font-family: Quicksand;
    line-height: 60px;
    font-weight: 500;
    font-size: 48px;
    color: #4d5d77;

    @media (max-width: 767.8px) {
      line-height: 40px;
      font-size: 30px;
    }
  }

  p {
    ${tw`bg-white bg-opacity-90 md:w-10/12 xl:w-6/12 text-center`};
    font-family: Quicksand;
    line-height: 30.6px;
    font-weight: 400;
    font-size: 18px;
    color: #6d6d88;
  }
`;

export const StripMessageWrapper = styled.div`
  ${tw`flex flex-col md:flex-row items-center justify-between gap-4 sticky top-0 p-4 md:px-8 md:py-2`};
  z-index: 11;

  .message {
    ${tw`flex justify-center items-center text-center md:text-left`};
    font-size: 14px;
  }
  
  a {
    font-size: inherit;
    min-width: 6rem;
    color: inherit;
  }
`;

export const FooterWrapper = styled.footer`
  ${tw`flex flex-col gap-6 px-7 md:px-10 pt-10 pb-6 text-white bg-white`};

  &.light {
    color: #42526e;

    .top {
      border-bottom: 1px solid rgba(51, 52, 71, 0.5);

      .social-icons a {
        border: 1px solid rgba(51, 52, 71, 0.5);
      }
    }

    ul a {
      color: #42526e;
    }
  }

  &.dark {
    background-color: #333447;
  }
  
  ul {
    ${tw`list-none pl-0`};

    a {
      ${tw`text-white hover:underline`};
      font-size: 0.925rem;
    }
  }
  
  .bottom {
    ${tw`flex flex-col md:flex-row gap-2 justify-between`};
    
    .right {
      ${tw`flex md:order-1 items-center justify-center md:justify-start flex-grow`};
      font-size: 1.029rem;
    }
    
    .left {
      ${tw`md:order-2 flex gap-4 md:gap-8 lg:gap-24 justify-center md:justify-end items-center flex-grow`};
      
      a {
        font-size: 1.029rem;
      }
    }
  }
  
  .top {
    ${tw`flex flex-col gap-4 md:gap-32 justify-between pb-8`};
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    
    @media (max-width: 991px) {
      ${tw`gap-8`}
    }
    
    @media (min-width: 992px) {
      ${tw`flex-row`}
    }
    
    .links {
      ${tw`flex flex-col md:flex-row gap-6 flex-grow justify-between`};
    }
    
    .section {
      h2 {
        font-family: Open sans;
        font-size: 1.029rem;
        font-weight: 700;
        ${tw`mb-2`};
      }
      
      ul {
        ${tw`flex flex-col gap-2`};
      }
      
      &.brand {
        ${tw`flex flex-col justify-center gap-4 lg:w-1/4`};
        
        @media (min-width: 992px) {
          ${tw`justify-start`}
        }
        
        .social-icons {
          ${tw`flex gap-4 items-center justify-center`};
          
          @media (min-width: 992px) {
            ${tw`justify-start`}
          }
          
          a {
            ${tw`flex items-center justify-center rounded-full w-8 h-8 bg-white`};
            
            &:hover {
              background-color: #e6e6e6;
            }
            
            svg {
              ${tw`w-5 h-5`};
            }
          }
        }
        
        .logo {
          ${tw`inline-block flex justify-center`};
          
          img {
            width: 150px;
          }
          
          @media (min-width: 992px) {
            ${tw`justify-start`}
          }
        }
      }
    }
  }
`;

export const NavbarWrapper = styled.header`
  ${tw`sticky z-10 top-0 flex w-full justify-between items-center p-4`};
  background-color: var(--theme-color, white);
  
  .link {
    ${tw`flex gap-4 relative px-4 cursor-pointer`};
    color: rgb(66, 82, 110);
    font-family: Quicksand;
    font-size: 1.029rem;
    font-weight: 500;
    
    a {
      color: rgb(66, 82, 110);
      font-weight: 500;
    }

    &.navbar-toggler {
      ${tw`px-0`};
    }

    &.brand {
      ${tw`absolute left-1/2 transform -translate-x-1/2 p-0 outline-none focus:outline-none`};
      line-height: 0;
      width: 100px;

      img {
        width: 100%;
      }
    }

    &:hover {
      .dropdown .menu {
        ${tw`flex`};
      }
      
      a {
        color: rgba(26, 140, 175, 1);
      }
    }
  }
  
  .right {
    ${tw`relative`};

    &.mobile .link {
      ${tw`pr-0`};
    }

    &:not(.mobile) {
      ${tw`hidden`};

      &.expand {
        ${tw`absolute top-full left-0 w-full bg-white flex flex-col gap-6 items-start pb-8 overflow-auto`};
        -ms-overflow-style: none;
        scrollbar-width: none;
        max-height: 80vh;

        ::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }

  button {
    ${tw`hover:border-none border-none bg-transparent hover:bg-transparent rounded-none p-0 m-0`};
    line-height: 0;
  }

  @media (min-width: 992px) {
    ${tw`px-8 py-4`};

    .link.brand {
      ${tw`relative translate-x-0 left-0`};
      width: 130px;
    }

    .right {
      ${tw`hidden justify-end items-center`};

      &:not(.mobile) {
        ${tw`flex`};

        &.expand {
          ${tw`relative flex-row gap-0 items-center pb-0`};
          max-height: unset;
          overflow: unset;
        }

        .link.auth {
          ${tw`px-0 justify-end`};

          a {
            font-size: 1.029rem;
          }
        }
      }
    }

    .navbar-toggler {
      ${tw`hidden`};
    }
  }
`;

export const FootnoteWrapper = styled.div`
  ${tw`flex flex-col gap-4 px-6 py-12 justify-center items-center`};
  background-color: #f1f8fe;

  h1 {
    ${tw`text-center mb-0`};
    font-family: Quicksand;
    line-height: 45px;
    font-weight: 500;
    font-size: 40px;
    color: #4d5d77;

    @media (max-width: 767.8px) {
      line-height: 32px;
      font-size: 27px;
    }
  }

  p {
    ${tw`text-center mb-3`};
    font-family: Quicksand;
    line-height: 30.6px;
    font-weight: 400;
    font-size: 18px;
    color: #6d6d88;
  }
`;

export const DropdownWrapper = styled.div`
  ${tw`relative`};

  .title, .title a {
    ${tw`flex gap-3 items-center relative`};
    color: rgb(66, 82, 110);
    font-size: 1.029rem;
    font-weight: 500;
    line-height: 1;

    &:hover, &:hover a {
      ${tw`hover:no-underline`};
      color: #00afbf;
    }
  }

  .menu {
    ${tw`relative hidden flex-col px-2 pt-6 pb-4 bg-white gap-6 z-10`};

    &.resources .item {
      ${tw`gap-4`};

      .sub-item a {
        font-family: Quicksand;
        font-size: 0.925rem;
        font-weight: 700;
        color: #42526e;
      }
    }

    @media (min-width: 992px) {
      ${tw`absolute px-12 py-8 gap-10 flex-row transform -translate-x-1/2 rounded-lg`};
      box-shadow: 0 4px 7px rgba(0, 0, 0, 0.1);
      left: 30% !important;

      &.resources .item {
        ${tw`flex-row gap-8`};

        .sub-item {
          ${tw`w-32`};
        }
      }

      &.solution .item {
        ${tw`w-44`};

        &:last-of-type {
          ${tw`w-32`};
        }
      }

      &.features .item {
        ${tw`w-32`};

        .sub-item a {
          font-size: 0.925rem
        }
      }
    }

    .item {
      ${tw`flex flex-col gap-4`};

      h3 {
        font-family: "Open sans";
        font-size: 1.029rem;
        font-weight: 700;
        line-height: 1;
        color: #42526e;
      }

      .sub-item {
        ${tw`flex flex-col gap-3`};

        a {
          ${tw`underline hover:no-underline`};
          color: rgb(66, 82, 110);
          font-size: 1.029rem;
          font-weight: 500;
          line-height: 1.2;
  
          &:hover {
            color: #00afbf;
          }
        }

        p {
          font-family: "Open sans";
          font-size: 0.9rem;
          font-weight: 700;
          line-height: 1.2;
          color: #545573;
        }
      }
    }
  }
`;

export const LoaderWrapper = styled.div`
  ${tw`bg-white mx-auto h-full w-full rounded-xl flex flex-col gap-8 items-center justify-center`};
  font-family: Circular Std !important;
  
  &.page-loader {
    min-height: 50vh;
  }

  svg {
    stroke: #00a0c6;
  }
`;

export const PageWrapper = styled.div`
  ${tw`flex flex-col relative`};

  .container {
    ${tw`flex flex-col relative`};

    &.with-sticky-list {
      ${tw`md:flex-row items-start`};

      .main {
        ${tw`lg:w-9/12 xl:w-10/12 xl:pr-10`};
      }
    }

    .main {
      ${tw`relative`}
    }
  }
`;